module.exports = __webpack_public_path__ + "img/robert.ff2e33fa.jpg";